import React from 'react';
import { ChevronLeft } from '@finect/tabular-icons/chevronLeft';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { ControlsContainer, ControlLeftButtonContainer, ControlButton, ControlRightButtonContainer } from './partials';
var controlsSizes = {
  small: '16',
  medium: '24',
  large: '32'
};
export var Controls = function Controls(_ref) {
  var onPrevClick = _ref.onPrevClick,
    onNextClick = _ref.onNextClick,
    left = _ref.left,
    right = _ref.right,
    alwaysShowControls = _ref.alwaysShowControls,
    controlsSize = _ref.controlsSize,
    controlsColor = _ref.controlsColor;
  var sizeControl = controlsSizes[controlsSize];
  return React.createElement(ControlsContainer, {
    alwaysShowControls: alwaysShowControls
  }, React.createElement(ControlLeftButtonContainer, {
    onClick: onPrevClick,
    visible: left
  }, React.createElement(ControlButton, {
    controlsColor: controlsColor
  }, React.createElement(ChevronLeft, {
    size: sizeControl
  }))), React.createElement(ControlRightButtonContainer, {
    onClick: onNextClick,
    visible: right
  }, React.createElement(ControlButton, {
    controlsColor: controlsColor
  }, React.createElement(ChevronRight, {
    size: sizeControl
  }))));
};